import { LoadingState } from '@lcs/shared/api';
import { createFeatureSelector, on } from '@ngrx/store';
import { OrderingOption } from 'generated/graphql-types';
import { RegisterState } from 'src/app/common-components/register/models/register-state';
import {
   RegisterAdapter,
   createRegisterAdapter,
} from 'src/app/common-components/register/models/register-state.adapter';
import { CallParkingLotFilterOptions } from '../models/call-parking-filter-option';
import { CallParkingRegisterOptions } from '../models/call-parkinglot-register-options';
import { CallParkingLotRegisterListItem } from '../models/call-parkinglot-register-results.model';
import * as callParkingLotRegisterActions from './call-parkinglot-register.actions';
import { callParkingLotRegisterAdapterActions } from './call-parkinglot-register.actions';

export const callParkingRegisterFeatureKey = 'callParkingRegister';
export interface CallParkingLotRegisterState
   extends RegisterState<CallParkingLotRegisterListItem, CallParkingRegisterOptions, OrderingOption> {
   filters: CallParkingLotFilterOptions[];
}

const adapter: RegisterAdapter<CallParkingLotRegisterListItem, CallParkingRegisterOptions, OrderingOption> =
   createRegisterAdapter<CallParkingLotRegisterListItem, CallParkingRegisterOptions, OrderingOption>({
      selectId: (callLogsRegisterItem) => {
         return callLogsRegisterItem.parkingSlotNumber ?? 0;
      },
   });

const initialState: CallParkingLotRegisterState = {
   ...adapter.getInitialState(),
   filters: [],
};

export const callLogsRegisterReducer = adapter.createReducer(
   callParkingLotRegisterActions.callParkingLotRegisterAdapterActions,
   initialState,
   on(callParkingLotRegisterActions.callParkingLotRegisterAdapterActions.pageEnter, (state) => {
      return {
         ...state,
         callState: LoadingState.Loading,
      };
   }),
   on(callParkingLotRegisterActions.callParkingLotRegisterAdapterActions.loadSuccess, (state, action) => {
      return {
         ...state,
         callLogs: action.items,
         callState: LoadingState.Loaded,
         endCursor: action.endCursor,
         hasNextPage: action.hasNextPage,
         totalCount: action.totalCount,
      };
   }),
   on(callParkingLotRegisterActions.callParkingLotsRegisterInitialFilter, (state, action) => {
      return {
         ...state,
         callState: LoadingState.Loading,
         filters: action.filters,
      };
   }),
   on(callParkingLotRegisterAdapterActions.quickFilterChanged, (state, action) => {
      return {
         ...state,
         callState: LoadingState.Loading,
         quickFilters: {
            ...state.quickFilters,
            ...action.quickFilters,
         },
      };
   })
);
export const callParkingLotRegiserSelector =
   createFeatureSelector<CallParkingLotRegisterState>(callParkingRegisterFeatureKey);
export const selectors = adapter.getSelectors(callParkingLotRegiserSelector);
export const { selectAll, selectCallState, selectTotalCount, selectEndCursor, selectQuickFilters } =
   adapter.getSelectors(callParkingLotRegiserSelector);
